var _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.38 73.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        fill: #808285;\n        font-family: AdobeClean-Bold, 'Adobe Clean';\n        font-size: 68px;\n        font-weight: 700;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: .01em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        letter-spacing: 0em;\n      }\n\n      .cls-9 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        letter-spacing: 0em;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 56.64) scale(.69 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 34.14,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 63.78,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 101.32,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 135.93,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.31,
    y: 0
  }, "ul"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 227.39,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 262,
    y: 0
  }, "d "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 314.49,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 359.58,
    y: 0
  }, "el"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 411.33,
    y: 0
  }, "iv"), /*#__PURE__*/React.createElement("tspan", {
    x: 461.24,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 495.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 519.65,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 536.51,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 571.53,
    y: 0
  }, "s"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.59d16c53c2b7ffd2640e72b443bdd4ea.svg";
export { ForwardRef as ReactComponent };